/**
 * Onboarding Step IDs Constants
 * Centralized constants for all onboarding step identifiers used throughout the application.
 */

export const ONBOARDING_STEP_IDS = {
  INVITE_TEAM_MEMBERS: 'inviteYourTeamMembers',
  ADD_LOGO: 'addYourLogo',
  APPLY_LINK: 'applyLink',
  TURN_ON_APPLICANT_SCREENING: 'turnOnApplicantScreening',
  CONNECT_PROPERTY_UPLOADER: 'connectPropertyUploader',
  SETUP_ENQUIRY_AUTORESPONDER: 'setUpTheEnquiryAutoResponder',
  CONNECT_UTILITY_PROVIDER: 'connectUtilityProvider',
  CONNECT_PROPERTY_MANAGEMENT_SYSTEM: 'connectYourPropertyManagementSystem',
  CUSTOMISE_APPLICATION_SETTINGS: 'customiseYourApplicationSettings',
  CUSTOMISE_VIEWINGS: 'customiseYourViewings',
  CONNECT_STAFFLINK: 'connectStafflink',
  LEASE_OFFER_CONGRATULATIONS_TEMPLATE: 'leaseOfferCongratulationsTemplate',
  BOOK_TRAINING: 'bookTraining',
  TURN_OFF_LEGACY_SYSTEMS: 'turnOffLegacySystems',
} as const

export type OnboardingStepId =
  typeof ONBOARDING_STEP_IDS[keyof typeof ONBOARDING_STEP_IDS]
